import { apiClient } from './apiClient';
import { normalizeAgentsResponse } from './normalizers';

const base = '/api/agents';

export const agentService = {
  list: params => {
    const queryString = params ? '?' + new URLSearchParams(params).toString() : '';
    return apiClient.get(`${base}${queryString}`).then(normalizeAgentsResponse);
  },
  get: id => apiClient.get(`${base}/${id}`).then(normalizeAgentsResponse),
  create: payload => apiClient.post(base, payload).then(normalizeAgentsResponse),
  update: (id, payload) =>
    apiClient.put(`${base}/${id}`, payload).then(normalizeAgentsResponse),
  remove: id => apiClient.del(`${base}/${id}`).then(normalizeAgentsResponse),
  test: (id, testData) => apiClient.post(`${base}/${id}/test`, testData),
  getEmbed: id => apiClient.get(`${base}/${id}/embed`),
  saveEmbed: (id, payload) => apiClient.post(`${base}/${id}/embed/save`, payload),
  getHoldMusic: id => apiClient.get(`${base}/${id}/hold-music`),
  saveHoldMusic: (id, payload) => apiClient.post(`${base}/${id}/hold-music/save`, payload),
};

export default agentService;
